/**
 * Human-readable file size: 58262 -> "56.9 KB".
 *
 * Returns '' for missing or invalid input so callers can supply their own
 * placeholder ('—', 'Unknown', etc.) where one is wanted.
 */
export function formatFileSize(bytes?: number | null): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return ''
  if (bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  )
  const value = bytes / 1024 ** exponent
  return `${parseFloat(value.toFixed(exponent === 0 ? 0 : 1))} ${units[exponent]}`
}
